import { conditionalStage } from './conditionalStage'

type SizeInput = {
  width?: number
  height?: number
}

const getBasePath = () => {
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID
  const regionId = process.env.REACT_APP_FIREBASE_REGION
  const isDev = process.env.NODE_ENV === 'development'

  const path = [
    ...conditionalStage(isDev, ['http:']),
    ...conditionalStage(!isDev, ['https:']),
    '//',
    window.location.hostname,
    ...conditionalStage(isDev, [':5001', `/${projectId}/${regionId}`]),
    '/getImageFromPath'
  ]

  return path.join('')
}

export const getOptimizedImage = (url: string | null, size?: SizeInput) => {
  if (!url) {
    return
  }

  const bucket = 'images'
  const res = url.split('images%2F')

  if (!res || !res[1]) {
    return
  }

  const res2 = res[1].split('?')

  if (!res2 || !res2[0]) {
    return
  }

  const location = `${bucket}/${res2[0]}`
  const base = getBasePath()
  const path = [
    base,
    `?imagePath=`,
    location,
    ...conditionalStage(!!size?.height, [`&height=${size?.height}`]),
    ...conditionalStage(!!size?.width, [`&width=${size?.width}`])
  ]

  return path.join('')
}
